import Animation from '../../animations/animation'
import * as d3 from 'd3-selection'

/*
 * Animation used to take more than one line
 * and combine those lines into a single line.
 */
class UnsplitLines extends Animation {

  constructor (options) {
    super(options)
    this.ripple = true
  }

  match (serie) {
    if (!this.previous.scalers.x || !this.seriesChanged) {
      // We don't have previous data or series didn't change
      return false
    }

    let ticks0 = this.previous.scalers.x.groupScale.domain()
      , ticks1 = this.scalers.x.groupScale.domain()
      , newSeries = this.series.filter(serie => {
        return this.previous.series.data().indexOf(serie) === -1 // We didn't have this serie previously
      })

    return ticks0.length === ticks1.length && // Same tick count on bottom
           this.exitingSeries.size() > 1 && // More than one serie being removed
           newSeries.size() === 1 // One new serie
  }

  animate (serie, entering, selection, merged, exiting) {
    if (entering.size()) {
      let self = this
        , scaler = {
          x: this.scalers.x.center,
          y: this.yScale
        }

      // This is the new line. Let's get it in the DOM
      this._insertPaths(entering)

      // We want to to hide the new path using a dasharray, so show it as we transition
      let totalLength = entering.select('path').node().getTotalLength()
      entering.selectAll('path')
              .attr('stroke-dasharray', `${totalLength} ${totalLength}`)
              .attr('stroke-dashoffset', `${totalLength}`)

      // Then add the points at the location of the exiting series points
      // The start and end scalers are the same, so the points code doesn't
      // try moving them. We'll handle that transition so we can work the `path`
      // at the same time.
      this._points(entering, scaler, scaler)

      // The points on the new path shouldn't be visible at first
      entering.selectAll('.point')
             .style('display', 'none')

      // Now take all the exiting series and have them converge to the new line
      this.exitingSeries.each(function (exitingSerie) {
        let selection = d3.select(this)
          , points = selection.selectAll('.point')

        points.transition(merged) // Inherit the merged transition
              .duration(self.timing.duration)
              .delay(self.timing.delay)
              .tween('splitter', self._splitTweener(exitingSerie, d => {
                return serie.points.find(point => point.rangeId === d.rangeId)
              }))
              .on('end', function (d, i, all) {
                let x = self.previous.scalers.x.center(d3.select(all[i]).datum().rangeId)
                  , length = self._subLength(selection, x)
                  , totalLength = entering.selectAll('path').node().getTotalLength()
                  , previousPoints = entering.selectAll('.point:not(.head)')
                                             .filter(d => {
                                               return Math.round(self.scalers.x.center(d.rangeId)) <= x
                                             })

                self._growPath(entering.selectAll('path'), length, totalLength, previousPoints)
              })
      })

      merged.end().then(() => {
        // Remove the stroke dasharray when transitions have finished
        entering.selectAll('path')
                .attr('stroke-dashoffset', '')
                .attr('stroke-dasharray', '')
      })
    } else if (!exiting.size()) {
      // Line isn't new or being removed, just update it
      this._updateDrawing(merged) // update in case scale changed
    }
  }

}

export default UnsplitLines
